exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.js-preview {\n    opacity: 1;\n    -webkit-transition: opacity 3.5s, border 2s;\n    transition: opacity 3.5s, border 2s;\n}\n.js-preview--error {\n    border: 1px solid #d63031 !important;\n    color: #d63031 !important;\n    opacity: 0 !important;\n}\n.js-preview__item {\n    opacity: 0;\n    -webkit-transition: opacity 2s;\n    transition: opacity 2s;\n}\n.js-preview__item--visible {\n    opacity: 1;\n}\n", ""]);

// exports
